import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
declare var jQuery: any;
declare var $: any;

@Injectable()
export class ValidationService {

  constructor() { }

  isFieldValid(formGroup: FormGroup, field: string) {
    if (!formGroup.get(field).valid && formGroup.get(field).touched) {
      if (formGroup.get(field).errors) {
        var str = this.checkField(field).replace(/\_/g, ' ');
        str = str.replace('id', '')
        var ctrl = (str.charAt(0).toUpperCase() + str.slice(1));
        if (formGroup.get(field).errors.minlength) {
          return ctrl + ' must be minimum ' + formGroup.get(field).errors.minlength.requiredLength + ' character long.';
        }
        if (formGroup.get(field).errors.maxlength) {
          return ctrl + ' must not be greater than ' + formGroup.get(field).errors.maxlength.requiredLength + ' character.';
        }
        if (formGroup.get(field).errors.email) {
          return 'Invalid email address';
        }
        if (formGroup.get(field).errors.required) {
          return ctrl + ' is required';
        }
      }
      return true;
    }
    else {
      var res = null;
      if (field == 'c_password' || field == 'confim_password')
        res = this.passwordMatchValidator(formGroup, field);
      return res;
    }
  }
  checkField(field) {
    var actual_field = '';
    switch (field) {
      case 'c_password':
        actual_field = 'Confirm password';
        break;
      case 'old_password':
        actual_field = 'current password';
        break;
      default:
        actual_field = field;
    }
    return actual_field;
  }

  passwordMatchValidator(formGroup: FormGroup, field: string) {
    if (formGroup.get('password')) {
      return formGroup.get('password').value === formGroup.get(field).value ? null : 'Confirm password must be equal to Password.';
    }
    else if (formGroup.get('new_password')) {
      return formGroup.get('new_password').value === formGroup.get(field).value ? null : 'Confirm password must be equal to New password.';
    }
  }

  displayFieldCss(formGroup: FormGroup, field: string) {
    return {
      'has-error': this.isFieldValid(formGroup, field),
      'has-feedback': this.isFieldValid(formGroup, field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/services/validation.service.ts